export default "__VITE_ASSET__DZgAwIWY__"